import type { ReactElement } from "react";
import * as React from "react";

export default function RightChevronWithShadowIcon(props: React.SVGProps<any>): ReactElement {
  return (
    <svg width="1em" height="1em" viewBox="0 0 84 118" {...props}>
      <defs>
        <filter
          x="-90%"
          y="-48.6%"
          width="280%"
          height="197.3%"
          filterUnits="objectBoundingBox"
          id="rightChevronWithShadowFilter"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter" />
          <feGaussianBlur stdDeviation={12} in="shadowOffsetOuter" result="shadowBlurOuter" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" in="shadowBlurOuter" />
        </filter>
        <path
          d="M62.56 40.663L32.389 72.481c-1.919 2.025-5.03 2.025-6.95 0-1.918-2.023-1.918-5.305 0-7.328L52.138 37 25.44 8.847c-1.919-2.025-1.919-5.306 0-7.329 1.918-2.024 5.03-2.024 6.95 0l30.172 31.818A5.312 5.312 0 0164 37c0 1.327-.48 2.653-1.44 3.664z"
          id="rightChevronWithShadowPath"
        />
      </defs>
      <g transform="translate(-2 22)" fillRule="nonzero" fill="none">
        <use fill="#000" filter="url(#rightChevronWithShadowFilter)" xlinkHref="#rightChevronWithShadowPath" />
        <use fill="#FFF" xlinkHref="#rightChevronWithShadowPath" />
      </g>
    </svg>
  );
}
